import { render } from "./ParticipationDeleteWidget.vue?vue&type=template&id=50984de1&ts=true"
import script from "./ParticipationDeleteWidget.ts?vue&type=script&lang=ts&external"
export * from "./ParticipationDeleteWidget.ts?vue&type=script&lang=ts&external"

import "./ParticipationDeleteWidget.vue?vue&type=style&index=0&id=50984de1&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__